import TableCell from './TableCell';
import { withStyles } from '@material-ui/core/styles';

export default withStyles({
  root: {
    backgroundColor: '#1689FA',
    color: '#FFFFFF',
  },
})(TableCell);
